import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Review from '../../../components/Review';
import { useSelector } from 'react-redux';
import ArrowBack from '../../../components/ArrowBack';
import closeFlow from '../../../utils/closeFlow';
import { getAgentOTP } from '../../../api';
import { selectFirebaseJWT, selectPhoneNumber } from '../../../redux/features/user/userSlice';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import Estimate from '../../../components/Estimate';

const AgentReview = ({ changeStep, data }) => {
  const userToken = useSelector(selectFirebaseJWT);
  const userPhone = useSelector(selectPhoneNumber);
  const [localLoading, setLocalLoading] = useState();
  // console.log(data);
  // NOTE: Do NOT send OTP here. Just advance the step.
  const handleContinue = () => {
    changeStep(1);
  };

  return (
    <div className='send-step'>
      <ArrowBack handle={() => changeStep(-1)} />

      <div className='payment-title'>
        <h6 className='el-title-h6 med'>Review details of your transfer</h6>
      </div>

      <div className='send-step-content'>
        <Review changeStep={changeStep} agentToAgentData={data} />

        <div className='send-step-content-rewards'>
          {data?.userReview?.transferRewardsInPesa && (
            <Estimate
              type={'large'}
              count={data?.userReview?.transferRewardsInPesa}
              text={'Reward for transaction'}
            />
          )}
        </div>

        <div className='send-btns'>
          <div className='send-btns-continue'>
            <LoadingButton
              disabled={localLoading}
              loading={localLoading}
              onClick={handleContinue}
              className='el-button orange'
            >
              <span>{localLoading ? 'Processing' : 'Continue'}</span>
            </LoadingButton>
          </div>

          <div className='send-btns-cancel'>
            <span className='el-link-m el-button-link' variant='contained' onClick={closeFlow}>
              Cancel
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

AgentReview.propTypes = {
  changeStep: PropTypes.func.isRequired,
};
export default AgentReview;
